

















































































































































































































































import $ from 'jquery'
import '../../styles/goods-listTr.less'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import HotTop from '@/components/public/HotTop.vue'
import Recommend from '@/components/public/Recommend.vue'
import listApi from '@/api/listApi'
import router from '@/router'
import utils from '@/utils/utils'
import { Input } from 'ant-design-vue'
import ShowImg from '@/components/ui/ShowImg.vue'
import NoData from '@/components/ui/NoData.vue'
/**
 * 商品列表页面
 */
@Component({
  components: {
    HotTop,
    Recommend,
    ShowImg,
    NoData
  }
})
export default class GoodsList extends Vue {

  @Prop({ default: '{}' }) private params: string
  private defaultParams = {
    page: 1,
    size: 10,
    resourceName: '',
    minPrice: '',
    maxPrice: '',
    purchaseCoinType: '',
    provinceCode: [] as any[],
    firstCategorySignCode: '',
    categorySignName: ''
  }

  private req: any = {

  }

  private res: any = {
    provinceList: [],
    citys: [],
    goodsListTop: [],
    goodsListLeft: [],
    selectionList: [],
    categoryList: [],
  }

  private crumbs: any[] = []

  private filter = {
    resourceType: '',
    firstCategorySignCode: '',
    area: {
      multiSelect: false, // 是否多选
      multiSelectId: [] as any[], // 多选的id
      provinces: [] as any[], // 所有的省
    },
    price: {
      min: 0,
      max: 0,
      items: [
        { minPrice: '0', maxPrice: '1000', id: 1 },
        { minPrice: '1001', maxPrice: '2000', id: 2 },
        { minPrice: '2001', maxPrice: '4000', id: 3 },
        { minPrice: '4001', maxPrice: '6000', id: 4 },
        { minPrice: '6001', maxPrice: '', id: 5 }
      ]
    },
    coinTypes: [{ name: '不限', value: '' }, { name: '金币', value: 'GOLDCOINS' }, { name: '银币', value: 'SILVERCOINS' }],
  }

  private checkType: any = {
    indeterminate: false,
    checkAll: false,
    checkArr: []
  }

  private sortType: string = ''
  private sortOrder: string = 'asc'

  private pagination: any = { // 分页
    pageSize: 10,
    total: 1000,
  }

  public mounted() {
    this.handleParams()
    this.getProvinceAll()
    this.getCategoryList()
    this.getResourcesListTop()
    this.getResourcesListLeft()
    if (this.$route.query.firstCategorySignCode && this.$route.query.categorySignName) {
      this.go({ firstCategorySignCode: this.$route.query.firstCategorySignCode, categorySignName: this.$route.query.categorySignName })
    }
    this.query()
  }

  @Watch('$route')
  public watchRouter(router: any) {
    if (this.$route.name === router.name) {
      this.handleParams()
      this.query()
    }
  }

  private handleParams() {
    let queryParams = {}
    if (typeof (this.params) == 'string') {
      try {
        queryParams = JSON.parse(this.params)
      } catch (e) { }
    } else {
      queryParams = this.params
    }

    this.req = $.extend(true, {}, this.defaultParams, queryParams)
    this.filter.price.min = this.req.minPrice || ''
    this.filter.price.max = this.req.maxPrice || ''
    this.filter.firstCategorySignCode = this.req.firstCategorySignCode || ''
  }

  private handleCrumbs() {
    this.crumbs = []
    if (this.req.purchaseCoinType) {
      this.crumbs.push({ type: 'purchaseCoinType', title: this.req.purchaseCoinType })
    }
    if (this.req.minPrice && this.req.maxPrice) {
      this.crumbs.push({ type: 'range', rangeMin: this.req.minPrice, rangeMax: this.req.maxPrice })
    }
  }

  protected query(): void {
    listApi.getSearchData(this.req).then((res) => {
      if (res.code === 200) {
        this.res.selectionList = res.data.content
        this.pagination.total = res.data.totalElements
        // if (this.res.selectionList.length === 0) {
          // this.$message.warning('暂无数据')
        // }
      }
    })
  }

  protected go(params: any): void {
    let p = JSON.stringify($.extend(true, this.req, params))
    this.$router.push({ name: this.$route.name, query: { params: p } })
  }

  // 获取资源类目
  protected getCategoryList(): void {
    listApi.getCategoryList().then((res) => {
      if (res.code === 200) {
        this.res.categoryList = res.data
      }
    })
  }

  // 点击资源类目 
  protected checkCategory(item: any): void {
    // if (item) {
    //   this.go({ categorySignCode: item.signCode })
    // } else {
    //   this.req.categorySignCode = ''
    // }
    // console.log(item)
    this.go({ page: 1 })
    this.go({ firstCategorySignCode: item.signCode, categorySignName: item.name })
  }

  // 获取省份
  protected getProvinceAll() {
    listApi.getProvinceList().then((res) => {
      if (res.code === 200) {
        this.res.provinceList = res.data
      }
    })
  }

  // 点击省份
  protected changeProvince(item: any) {
    if (!this.filter.area.multiSelect) {
      let provinceCode = []

      if (item) {
        provinceCode = [item.id]

      } else { // 如何传入的值为 [] 且 req.provinces有值的情况下，无法通过对象合并覆盖里面的值
        this.req.provinceCode = []

      }
      this.go({ provinceCode })
    }
  }

  // 全选按钮
  protected onCheckAllChange(e: any) {
    this.checkType.checkAll = e.target.checked
    this.checkType.indeterminate = false
    this.filter.area.multiSelectId = []
    if (e.target.checked) {
      this.res.provinceList.forEach((v: any) => {
        this.filter.area.multiSelectId.push(v.id)
      });
    } else {
      this.req.provinceCode = []
      this.filter.area.multiSelectId = []
    }
  }

  // 改变城市按钮
  protected changeProvinces(e: any) {
    this.filter.area.multiSelectId = e
    this.checkType.indeterminate = e.length > 0 && e.length < this.res.provinceList.length
    this.checkType.checkAll = e.length === this.res.provinceList.length
  }

  // 多选
  protected multiselect() {
    this.req.provinceCode = []
    this.changeProvince('')
    this.filter.area.multiSelect = !this.filter.area.multiSelect
    // this.filter.area.more = !this.filter.area.more
  }

  // 选择金额范围
  protected priceChange(min: any, max: any) {
    this.go({ minPrice: min, maxPrice: max })
    if (max === '') {
      this.go({ minPrice: min, maxPrice: max })
      return
    } else {
      if (min * 1 > max * 1) {
        this.go({ minPrice: max, maxPrice: min })
      } else {
        this.go({ minPrice: min, maxPrice: max })
      }
    }
  }

  // 选择币种
  protected coinTypeChange(item: any) {
    this.go({ purchaseCoinType: item.value })
  }

  // 确定查询
  protected confirmSearch() {
    this.req.provinceCode = []
    console.log(this.filter.area.multiSelectId)
    this.go({ provinceCode: this.filter.area.multiSelectId })
  }

  // 取消多选
  protected cancelSearch() {
    this.checkType.checkAll = false
    this.checkType.indeterminate = false
    this.filter.area.multiSelect = false
    this.req.provinceCode = []
    this.filter.area.multiSelectId = []
    this.changeProvince('')
  }

  // 排序
  protected listSort(item: string) {
    this.sortType = item
    this.sortOrder = this.sortOrder !== 'asc' ? 'asc' : 'desc'
    this.go({ sortOrder: this.sortOrder })
  }

  // 分页
  protected changePage(page: number): void {
    this.go({ page })
  }

  // 详情
  private goDetails(item: any) {
    // if (item.purchasedStatus === 'SELL_OUT') {
    //   return
    // }
    this.$router.push({ name: 'goods-details', query: { id: item.id } })
  }

  // 获取资源头部
  private getResourcesListTop() {
    listApi.getHotList({
      businessType: 'PROMOTION',
      position: 'GOODS_LIST_TOP',
    }).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.res.goodsListTop = res.data
      }
    })
  }

  // 获取资源左边列表
  private getResourcesListLeft() {
    listApi.getHotList({
      businessType: 'PROMOTION',
      position: 'GOODS_LIST_LEFT',
    }).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.res.goodsListLeft = res.data
      }
    })
  }
}
